
//Run initialize
await initializeBundle();

//Event Listeners
if (document.addEventListener) {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
        document.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
            input.value = 0;
            inputChangeSubProduct(input);
            incrementEnableValidation(input);
            checkoutEnableValidation(input);
        });
      }
    },
    false);
}

document.querySelectorAll('[data-bundle-builder-selected-product-remove-button]').forEach(function(removeButton){
    removeButton.addEventListener('click', function(e){
        e.preventDefault();
        const triggeredProductWrapper = e.target.closest('[data-bundle-builder-selected-product-id]');
        productSelectionButtonClicked = true;
        productSelectionIndex = triggeredProductWrapper.getAttribute('data-index');
        const productID = triggeredProductWrapper.getAttribute('data-bundle-builder-selected-product-id');
        const bundleBlock = getBundleBlock(e.currentTarget);
        const bundleProduct = bundleBlock.querySelector(`[data-lsg-bundle-product-select-id='${productID}']`);
        const bundleProductDecrement = bundleProduct.querySelector('.lsg-bundle-product-select-quantity-minus');
        bundleProductDecrement.click();
    });
});

document.querySelectorAll('.lsg-bundle-product-select-quantity-increment').forEach(function(incrementButton){
    incrementButton.addEventListener('click', function(e){
        e.preventDefault();
        incrementSubProduct(e.currentTarget);
        buildSelectedProductArray(e.currentTarget);
        incrementEnableValidation(e.currentTarget);
        checkoutEnableValidation(e.currentTarget);
    })
});
document.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
    input.addEventListener('change', function(e){
        inputChangeSubProduct(e.currentTarget);
        incrementEnableValidation(e.currentTarget);
        checkoutEnableValidation(e.currentTarget);
    })
});
document.querySelectorAll('.lsg-bundle-interval-select input[name^="bundle_interval_select_"]').forEach(function(intervalSelector){
    intervalSelector.addEventListener('change', function(e){
        updateInterval(e.currentTarget);
        checkoutEnableValidation(e.currentTarget);
    });
});
document.querySelectorAll('.lsg-bundle-interval-frequency-select').forEach(function(frequencySelect){
    frequencySelect.addEventListener('change', function(e){
        const trigger = e.currentTarget;
        const frequencySelects = [...document.querySelectorAll('.lsg-bundle-interval-frequency-select')].filter( el => el != trigger);
        frequencySelects.forEach((select) => { select.value = trigger.value; });
        updateFrequency(e.currentTarget);
    })
});
/* document.querySelectorAll('.lsg-bundle-form').forEach(function(bundleForm){
    bundleForm.addEventListener('submit', function(e){
        e.preventDefault();
        addToCart(e.currentTarget);
    });
}); */
document.querySelectorAll('[data-lsg-bundle-atc]').forEach((bundleATC) => {
    bundleATC.addEventListener('click', function(e){
        e.preventDefault();
        if(e.currentTarget.classList.contains('disabled')) {
            //scroll to top of the bundle block
            const announcementOffset = parseInt(document.body.style.getPropertyValue('--announcement-offset').replace('px', '')) || 0;
            const headerOffset = parseInt(document.body.style.getPropertyValue('--header-offset').replace('px', '')) || 0;
            const offset = announcementOffset + headerOffset;
            const bundleBlock = getBundleBlock(e.currentTarget);
            window.scrollTo({ top: bundleBlock.offsetTop - offset, behavior: 'smooth' });
        } else {
            addToCart(e.currentTarget);
        }
    })
})
document.querySelectorAll('.lsg-bundle-size-select-el').forEach(function(bundleSelector){
    bundleSelector.addEventListener('click', function(e){
        e.preventDefault();
        setActiveBundle(e.currentTarget);
    });
});

const bundleObserver = new IntersectionObserver(([entry]) => {
    const bundleBlock = entry.target.closest('.lsg-bundle-block');
    if(bundleBlock) {
        bundleBlock.classList.remove('summary-is-below');
        bundleBlock.classList.remove('summary-is-above');
        bundleBlock.classList.remove('summary-is-visible');
        
        if(entry.isIntersecting) {
            // is visible
            bundleBlock.classList.add('summary-is-visible');
            return
        } else if(entry.boundingClientRect.top > 0) {
            // item is below view
            bundleBlock.classList.add('summary-is-below');
        } else {
            // item is above view
            bundleBlock.classList.add('summary-is-above');
        }
    }
});
const buyboxes = document.querySelectorAll('.lsg-bundle-summary-block');
buyboxes.forEach((buybox) => {
    bundleObserver.observe(buybox);
});

const bottomObserver = new IntersectionObserver(([entry]) => {
    const bundleBlocks = document.querySelectorAll('.lsg-bundle-block');
    if(entry.isIntersecting) {
        bundleBlocks.forEach((bundleBlock) => {
            bundleBlock.classList.add('is-scroll-bottom');
        })
    } else {
        bundleBlocks.forEach((bundleBlock) => {
            bundleBlock.classList.remove('is-scroll-bottom');
        })
    }
}, {
    threshold: 1
});
bottomObserver.observe(document.querySelector('.io-sub-footer'));

const prodMarkObserver = new IntersectionObserver(([entry]) => {
    const bundleBlock = entry.target.closest('.lsg-bundle-block');
    if(bundleBlock) {
        bundleBlock.classList.remove('prodmark-is-below');
        bundleBlock.classList.remove('prodmark-is-above');
        bundleBlock.classList.remove('prodmark-is-visible');
        
        if(entry.isIntersecting) {
            // is visible
            bundleBlock.classList.add('prodmark-is-visible');
            return
        } else if(entry.boundingClientRect.top > 0) {
            // item is below view
            bundleBlock.classList.add('prodmark-is-below');
        } else {
            // item is above view
            bundleBlock.classList.add('prodmark-is-above');
        }
    }
}, {
    threshold: 1
});
const prodMarkWrappers = document.querySelectorAll('.lsg-bundle-product-select-wrapper:nth-child(6)');
prodMarkWrappers.forEach((prodWrapper) => {
    prodMarkObserver.observe(prodWrapper);
});

let productSelectionButtonClicked = false,
    productSelectionIndex,
    selectedProducts = [];

  const buildSelectedProductArray = (trigger) => {
    const method = (trigger.classList.contains('lsg-bundle-product-select-quantity-minus') ? 'minus' : (trigger.classList.contains('lsg-bundle-product-select-quantity-plus') ? 'plus' : 'err'));
    const triggeredProductWrapper = trigger.closest('.lsg-bundle-product-select-wrapper');
    const productID = triggeredProductWrapper.getAttribute('data-lsg-bundle-product-select-id');
    const productTitle = triggeredProductWrapper.querySelector('.lsg-bundle-product-select-title').innerHTML;
    
    switch(method) {
        case 'minus':
            if (productSelectionButtonClicked == true) {
                selectedProducts.splice(productSelectionIndex, 1);
                productSelectionButtonClicked = false
            }
            else {
                productSelectionIndex = selectedProducts.findLastIndex(p => p.selectedProductId == productID);
                selectedProducts.splice(productSelectionIndex, 1);    
            }
            break;
        case 'plus':
            const productImageUrl = triggeredProductWrapper.querySelector('img').src;
            const productImageAlt = triggeredProductWrapper.querySelector('img').alt;
            let selectedProductData = {
                selectedProductImageUrl: productImageUrl,
                selectedProductId: productID,
                selectedProductTitle: productTitle,
                selectedProductImageAlt: productImageAlt,
            };
            selectedProducts.push(selectedProductData);
            break;
    }
    updateSelectedProductGUI(selectedProducts, trigger);
  }

  const updateSelectedProductGUI = (selectedProducts, trigger) => {
    const bundleBlock = getBundleBlock(trigger);
    if (selectedProducts.length > 0) {
        bundleBlock.classList.add('has-selected-product');
    } else {
        bundleBlock.classList.remove('has-selected-product');
    }

    const selectedProductsWrappers = bundleBlock.querySelectorAll('[data-bundle-builder-selected-products]');
    selectedProductsWrappers.forEach((selectedProductsWrapper) => {
        const selectedProductWrappers = selectedProductsWrapper.querySelectorAll('[data-bundle-builder-selected-product-id]');
    
        selectedProductWrappers.forEach((productWrapper, i) => {
            const selectedProductData = selectedProducts[i];
    
            const productWrapperImage = productWrapper.querySelector('[data-bundle-builder-selected-product-image]');
            const productWrapperTitle = productWrapper.querySelector('[data-bundle-builder-selected-product-title]');
    
            if (typeof selectedProductData !== 'undefined') {
                
                productWrapper.setAttribute('data-bundle-builder-selected-product-id', selectedProductData.selectedProductId);
    
                productWrapperImage.src = selectedProductData.selectedProductImageUrl;
                productWrapperImage.alt = selectedProductData.selectedProductImageAlt;
    
                productWrapperTitle.innerHTML = selectedProductData.selectedProductTitle;
    
                productWrapper.classList.add('active');
            } else {
                
                productWrapper.setAttribute('data-bundle-builder-selected-product-id', '');
                
                productWrapperImage.src = '';
                productWrapperImage.alt = '';
    
                productWrapperTitle.innerHTML = '';
    
                productWrapper.classList.remove('active');
                
            }
        });
    });
    
  }

function setActiveBundle(trigger) {
    //sets different bundle blocks active
    const bundleIndex = trigger.dataset.bundleIndex;
    const bundleWrapper = trigger.closest('.lsg-bundle-wrapper');
    const bundleBlocks = bundleWrapper.querySelectorAll('.lsg-bundle-block');
    const targetBundle = bundleWrapper.querySelector('[data-bundle-index="' + bundleIndex + '"].lsg-bundle-block');
    if(targetBundle) {
        bundleBlocks.forEach(function(bundleBlock){
            if(bundleBlock.dataset.bundleIndex != bundleIndex) {
                bundleBlock.classList.remove('lsg-bundle-block-active');
            } else {
                bundleBlock.classList.add('lsg-bundle-block-active');
            }
        });
    }
}

function incrementEnableValidation(trigger) {
    //trigger is input or increment buttons
    const productSetList = trigger.closest('.lsg-bundle-product-set-list');
    const quantityIncrementButtons = productSetList.querySelectorAll('.lsg-bundle-product-select-quantity-increment');
    const bundleQuantity = getBundleQuantityByChild(trigger);
    const bundleMax = productSetList.dataset.bundleMax;

    //increment button enable/disable
    quantityIncrementButtons.forEach(function(quantityIncrementButton){
        const method = (quantityIncrementButton.classList.contains('lsg-bundle-product-select-quantity-minus') ? 'minus' : (quantityIncrementButton.classList.contains('lsg-bundle-product-select-quantity-plus') ? 'plus' : 'err'));
        const input = quantityIncrementButton.closest('.lsg-bundle-product-select-quantity-wrap').querySelector('.lsg-bundle-product-select-quantity-input');
        const quantity = input.value;
        switch(method) {
            case 'minus':
                quantityIncrementButton.disabled = false;
                if(quantity <= 0) {
                    quantityIncrementButton.disabled = true;
                }
                if(quantity <= parseInt(input.min)) {
                    quantityIncrementButton.disabled = true;
                }
                break;
            case 'plus':
                quantityIncrementButton.disabled = false;
                if(quantity >= parseInt(input.max)) {
                    quantityIncrementButton.disabled = true;
                }
                if(parseInt(bundleMax) > 0) {
                    if(bundleQuantity >= parseInt(bundleMax)) {
                        quantityIncrementButton.disabled = true;
                    }
                }
                break;
        }
    });
}

function checkoutEnableValidation(trigger) {
    const bundleBlock = getBundleBlock(trigger);
    const addToCartButtons = bundleBlock.querySelectorAll('[data-lsg-bundle-atc');
    const bundleQuantity = getBundleQuantity(trigger);
    const interval = getBundleInterval(trigger);
    const bundleMin = (interval == 'otp' ? bundleBlock.dataset.otpBundleMin : bundleBlock.dataset.subBundleMin);
    const bundleMax = (interval == 'otp' ? bundleBlock.dataset.otpBundleMax : bundleBlock.dataset.subBundleMax);
    const quantityToAdd = bundleMax - bundleQuantity;

    //checkout button enable/disable
    addToCartButtons.forEach(function(addToCartButton){
        const addToCartText = addToCartButton.querySelector('[data-lsg-bundle-submit-button-atc-text]'); 
        const addMoreText = addToCartButton.querySelector('[data-lsg-bundle-submit-button-add-more-text]');
        const addMoreQuantity = addToCartButton.querySelector('[data-lsg-bundle-submit-button-add-more-quantity]');

        if(bundleQuantity >= bundleMin && (bundleQuantity <= bundleMax || bundleMax < bundleMin)) {
            addToCartButton.classList.remove('disabled');
            addToCartText.classList.remove('hidden');
            addMoreText.classList.add('hidden');
            bundleBlock.classList.add('bundle-checkout-enabled');
        } else {
            addToCartButton.classList.add('disabled');
            addToCartText.classList.add('hidden');
            addMoreText.classList.remove('hidden');
            addMoreQuantity.innerHTML = quantityToAdd;
            bundleBlock.classList.remove('bundle-checkout-enabled');
        }
    });
}

function addToCart(trigger) {
    const bundleID = getGuid();
    const bundleBlock = getBundleBlock(trigger);
    const bundleForm = bundleBlock.querySelector('.lsg-bundle-form');
    const bundleProductID = bundleForm.querySelector('input[name="id"]').value;
    const bundleSellingPlan = bundleForm.querySelector('input[name="selling_plan"]').value;
    const interval = (bundleSellingPlan == '' ? 'otp' : 'sub');
    const bundleMin = (interval == 'otp' ? bundleBlock.dataset.otpBundleMin : bundleBlock.dataset.subBundleMin);
    const bundleMax = (interval == 'otp' ? bundleBlock.dataset.otpBundleMax : bundleBlock.dataset.subBundleMax);
    const bundleProductList = bundleBlock.querySelector('.lsg-bundle-product-set-list');
    const bundleProductListInputs = bundleProductList.querySelectorAll('.lsg-bundle-product-select-quantity-input');
    const bundleWrapper = bundleBlock.closest('[data-lsg-bundle-wrapper]');
    const isRechargeBundle = bundleWrapper?.hasAttribute('data-recharge-product-id') && bundleWrapper?.hasAttribute('data-recharge-product-handle');
    const rechargeProductID = bundleWrapper?.getAttribute('data-recharge-product-id');
    const rechargeVariantID = bundleBlock?.getAttribute('data-recharge-variant-id');
    const rechargeProductHandle = bundleWrapper?.getAttribute('data-recharge-product-handle');
    const rechargeBundleParentId = bundleBlock?.getAttribute('data-recharge-bundle-parent-id');
    let rechargeBundleObj = {};
    let rechargeSelections = [];
    if (isRechargeBundle) {
        rechargeBundleObj.externalProductId = rechargeProductID;
        rechargeBundleObj.externalVariantId = rechargeVariantID;
    }
    let bundleCart = {
        'items': []
    };
    let bundleProductQuantity = 0;
    {
        let cartItem = {
            id: bundleProductID,
            quantity: 1,
            properties: {
              "_bundle_id": bundleID,
              "_bundle_parent": true,
              "_bundle_min": bundleMin,
              "_bundle_max": bundleMax,
            },
        };
        if (interval == 'sub') {
            cartItem["selling_plan"] = bundleSellingPlan;
        }
        bundleCart.items.push(cartItem);
    }
    bundleProductListInputs.forEach(function(bundleProductInput){
        bundleProductQuantity = bundleProductQuantity + parseInt(bundleProductInput.value);
        if(parseInt(bundleProductInput.value) > 0) {
            let cartItem = {
                id: bundleProductInput.dataset.product,
                quantity: parseInt(bundleProductInput.value),
                properties: {
                    "_bundle_id": bundleID,
                },
            };
            if (interval == 'sub') {
                cartItem["selling_plan"] = bundleSellingPlan;
            }
            bundleCart.items.push(cartItem);

            if (isRechargeBundle) {
                const rechargeCollectionID = bundleProductInput.getAttribute('data-collection-id');
                const externalProductID = bundleProductInput.getAttribute('data-external-product-id');
                const rechargeSelectionItem = {
                    collectionId: rechargeCollectionID,
                    externalProductId: externalProductID,
                    externalVariantId: bundleProductInput.getAttribute('data-product'),
                    quantity: parseInt(bundleProductInput.value)
                }
                if (interval == 'sub') {
                    const spgJSON = JSON.parse(bundleProductInput.getAttribute('data-spgs'));
                    const selectedSellingPlanOption = bundleBlock.querySelector(`[data-lsg-bundle-interval-select] select option[value="${bundleSellingPlan}"]`);
                    const spOptionValue = JSON.parse(selectedSellingPlanOption.getAttribute('data-selling-plan-options'))[1].value;
                    const filteredGroups = spgJSON.reduce((acc, cur) => {
                        if (cur.selling_plans.find(sp => {
                            return sp.options[1].value == spOptionValue
                        })) {
                            acc.push(cur);
                        }
                        return acc;
                    }, []);
                    if (filteredGroups[0]) {
                        const sellingPlan = filteredGroups[0].selling_plans.find(selling_plan => {
                            return selling_plan.options[1].value == spOptionValue;
                        });
                        if (sellingPlan) {
                            rechargeSelectionItem['sellingPlan'] = parseInt(sellingPlan.id);
                        }
                    }
                }
                rechargeSelections.push(rechargeSelectionItem);
            }
        }
    });
    if(bundleProductQuantity > bundleMax || bundleProductQuantity < bundleMin) {
        //quantity is not within bundle size
        return false;
    }

   
    if(document.querySelector('[bundle-straight-to-checkout') !== null && !isRechargeBundle){
        if(bundleCart.items[0].selling_plan) {
            // straight to checkout with selling plan
            const discount = document.querySelector('[bundle-straight-to-checkout]').dataset.subscribeDiscount
            let start = '/cart/clear?return_to=/cart/add?'
            let end = `return_to=/discount/${discount}?redirect=/checkout`

            bundleCart.items.forEach((item) => {
                start += `items[][id]=${item.id}%26items[][selling_plan]=${item.selling_plan}%26items[][quantity]=${item.quantity}%26items[][properties][_bundle_id]=${item.properties._bundle_id}`
                if (item.properties._bundle_parent) {
                    start += `%26items[][properties][_bundle_parent]=true%26items[][properties][_bundle_min]=${item.properties._bundle_min}%26items[][properties][_bundle_max]=${item.properties._bundle_max}`
                }
                start += `%26`
            })

            window.location.href = start + end

        } else {
            // straight to checkout WITHOUT selling plan
            const discount = document.querySelector('[bundle-straight-to-checkout]').dataset.otpDiscount

            let start = '/cart/clear?return_to=/cart/add?'
            let end = `return_to=/discount/${discount}?redirect=/checkout`

            bundleCart.items.forEach((item) => {
                start += `items[][id]=${item.id}%26items[][quantity]=${item.quantity}%26items[][properties][_bundle_id]=${item.properties._bundle_id}`
                if (item.properties._bundle_parent) {
                    start += `%26items[][properties][_bundle_parent]=true%26items[][properties][_bundle_min]=${item.properties._bundle_min}%26items[][properties][_bundle_max]=${item.properties._bundle_max}`
                }
                start += `%26`
            })

            window.location.href = start + end

        }
        return
    }


    if (isRechargeBundle) {
        rechargeBundleObj.selections = rechargeSelections;
        const rechargeBundleIsValid = recharge.bundle.validateDynamicBundle(rechargeBundleObj)
        if (rechargeBundleIsValid === true) {
            const rechargePayload = recharge.bundle.getDynamicBundleItems(rechargeBundleObj, rechargeProductHandle);
            if (rechargeBundleParentId) {
                const UUID = rechargePayload[0].properties._rc_bundle;
                if (UUID) {
                    rechargePayload.push({
                        id: rechargeBundleParentId,
                        properties: {
                            _rc_pseudo_bundle: UUID,
                        },
                        quantity: 1,
                    });
                }
            }
            const rechargeCartData = { items: rechargePayload };
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(rechargeCartData),
                credentials: 'same-origin'
            }).then(response => {
                if (response.status == 200) {
                    // window.location.href = "/cart";
                    // slideCartOpen();
                    /* setTimeout(() => {
                        Rebuy.SmartCart.show()
                    }, 500); */
                    window.NSS_REFRESH_AND_OPEN_CART();
                }
            }).catch(error => {
                console.error(error);
            });
        } else {
            console.log('recharge bundle settings invalid', rechargeBundleIsValid);
        }
    } else {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(bundleCart),
            credentials: 'same-origin'
        }).then((response) => {
            if(response.status == 200) {
                // window.location.href = "/cart";
                // slideCartOpen();
            }
        }).catch((error) => {
            console.error(error);
        });
    }
}

function updateFrequency(trigger) {
    //Render price and assign selling_plan in the form
    updateBundlePrice(trigger);
    updateSellingPlan(trigger);
}

function updateInterval(trigger) {
    //updates bundle block classes, resets displayed prices, and sets the selling_plan input value
    const bundleBlock = getBundleBlock(trigger);
    const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');

    switch(trigger.value) {
        case 'otp':
            bundleBlock.classList.remove('lsg-bundle--sub-selected');
            bundleBlock.classList.add('lsg-bundle--otp-selected');
            sellingPlanInput.value = '';
            break;
        case 'sub':
            bundleBlock.classList.remove('lsg-bundle--otp-selected');
            bundleBlock.classList.add('lsg-bundle--sub-selected');
            sellingPlanInput.value = frequencySelect.value;
            break;
    }

    updateBundlePrice(trigger);
    updateSellingPlan(trigger);
}

function updateSellingPlan(trigger) {
    //set form selling_plan based on selected state
    const bundleBlock = getBundleBlock(trigger);
    const selling_plan = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    if(selling_plan) {
        if(bundleBlock.classList.contains('lsg-bundle--sub-selected') || bundleBlock.classList.contains('lsg-bundle--only-sub')) {
            const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
            if(frequencySelect) {
                selling_plan.value = frequencySelect.value;
            } else {
                selling_plan.value = '';
            }
        } else {
            selling_plan.value = '';
        }
    }
}

function inputChangeSubProduct(trigger) {
    //validates quantities for bundle products when the input field is updated
    if(isNaN(trigger.value) || trigger.value == ''){
        trigger.value = 0;
    }

    if(trigger.value > parseInt(trigger.max)) {
        trigger.value = parseInt(trigger.max);
    }

    if(trigger.value < 0) {
        trigger.value = 0;
    }

    if(trigger.value < parseInt(trigger.min)) {
        trigger.value = parseInt(trigger.min);
    }

    const bundleMax = trigger.closest('.lsg-bundle-product-set-list').dataset.bundleMax;
    const bundleQuantity = getBundleQuantity(trigger);

    if((bundleQuantity > bundleMax) && bundleMax > 0) {
        let bundleDif = bundleQuantity - bundleMax;
        if(trigger.value >= bundleDif) {
            //reduce quantity to stay within bundle max
            trigger.value = (trigger.value - bundleDif);
        } else {
            //something went wrong, reset all values to min
            trigger.closest('.lsg-bundle-product-set-list').querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
                input.value = parseInt(input.min);
            });
        }
    }
    updateQuantityDisplay(trigger);
    updateBundlePrice(trigger);
}

function incrementSubProduct(trigger) {
    //validates quantities for the bundle products and updates the input when increment buttons are clicked
    const method = (trigger.classList.contains('lsg-bundle-product-select-quantity-minus') ? 'minus' : (trigger.classList.contains('lsg-bundle-product-select-quantity-plus') ? 'plus' : ''));
    const input = trigger.closest('.lsg-bundle-product-select-quantity-wrap').querySelector('.lsg-bundle-product-select-quantity-input');
    const bundleMax = trigger.closest('.lsg-bundle-product-set-list').dataset.bundleMax;
    const bundleQuantity = getBundleQuantity(trigger);

    switch(method) {
        case 'plus':
            if(input.value >= parseInt(input.max)) {
                //reset to inventory max if over
                input.value = parseInt(input.max);
            } else {
                if((bundleQuantity < parseInt(bundleMax)) || parseInt(bundleMax) < 1) {
                    input.value++;
                } else {
                    //at max bundle quantity, do not change
                }
            }
            updateBundlePrice(trigger);
            break;
        case 'minus':
            if(input.value <= parseInt(input.min)) {
                input.value = parseInt(input.min);
            } else if(input.value <= 0) {
                input.value = 0;
            } else {
                input.value--;
            }
            updateBundlePrice(trigger);
            break;
    }
    updateQuantityDisplay(input);
    mirrorQuantityDisplay(input);
}

function mirrorQuantityDisplay(input) {
    const bundleBlock = getBundleBlock(input);
    const productID = input.dataset.product;
    const quantity = input.value;
    const productInputs = bundleBlock.querySelectorAll('[data-product="' + productID + '"].lsg-bundle-product-select-quantity-input');
    productInputs.forEach(function(productInput){
        if(productInput !== input) {
            productInput.value = quantity;
            inputChangeSubProduct(productInput);
        }
    });
}

function updateQuantityDisplay(input) {
    const inputWrap = input.closest('.lsg-bundle-product-select-quantity-wrap');
    if (input.value <= 0) {
        $(inputWrap).addClass('no-quantity');
    } else {
        $(inputWrap).removeClass('no-quantity');
    }
    const inputDisplay = input.parentNode.querySelector('.lsg-bundle-product-select-quantity-input-display');
    if(inputDisplay) {
        inputDisplay.innerHTML = input.value;
    }
}

function updateBundlePrice(trigger) {
    //updates OTP/Sub pricing
    const bundleBlock = getBundleBlock(trigger);
    const otpPriceEls = bundleBlock.querySelectorAll('.lsg-bundle-interval-otp-price');
    const subPriceEls = bundleBlock.querySelectorAll('.lsg-bundle-interval-sub-price');
    const curPriceEls = bundleBlock.querySelectorAll('[data-bundle-total]');
    const frequency = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate) option:checked');
    const productList = bundleBlock.querySelector('.lsg-bundle-product-set-list');
    const bundleMin = productList.dataset.bundleMin;
    const bundleMax = productList.dataset.bundleMax;
    const hasIntervalSelect = bundleBlock.classList.contains('lsg-bundle--has-interval-select');
    const productBasePrice = parseInt(bundleBlock.dataset.productBasePrice);
    const productPriceOverride = parseInt(bundleBlock.dataset.productPriceOverride);
    const productPriceOverrideIndividual = parseInt(bundleBlock.dataset.productPriceOverrideIndividual);
    let interval = ''
    if(bundleBlock.classList.contains('lsg-bundle--only-otp') || bundleBlock.classList.contains('lsg-bundle--otp-selected')) {
        interval = 'otp';
    } else if (bundleBlock.classList.contains('lsg-bundle--only-sub') || bundleBlock.classList.contains('lsg-bundle--sub-selected')) {
        interval = 'sub';
    }
    let otpSubtotal = 0;
    let subSubtotal = 0;
    let curQuantity = 0;

    if(productList && interval == 'otp') {
        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(otpProductInput){
            let quantity = parseInt(otpProductInput.value);
            let price = parseInt(otpProductInput.dataset.price);
            curQuantity = curQuantity + quantity;
            otpSubtotal = otpSubtotal + (quantity * price);
            if(productList && frequency && hasIntervalSelect) {
                const discountType = frequency.dataset.discountType;
                const discountValue = frequency.dataset.discountValue;
                let discount = 0;
                switch(discountType){
                    case 'percentage':
                        discount = (price * parseFloat(discountValue)) / 100;
                        break;
                    case 'fixed_amount':
                        discount = parseInt(discountValue);
                        break;
                    case 'price':
                        discount = price - parseInt(discountValue);
                        break;
                }
                if(discount < 0) { discount = 0; }
                subSubtotal = subSubtotal + (quantity * (price - discount));
            }
        });
    }

    if(productList && frequency && interval == 'sub') {
        const discountType = frequency.dataset.discountType;
        const discountValue = frequency.dataset.discountValue;
        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(subProductInput){
            let quantity = parseInt(subProductInput.value);
            let price = parseInt(subProductInput.dataset.price);
            let discount = 0;
            curQuantity = curQuantity + quantity;
            switch(discountType){
                case 'percentage':
                    discount = (price * parseFloat(discountValue)) / 100;
                    break;
                case 'fixed_amount':
                    discount = parseInt(discountValue);
                    break;
                case 'price':
                    discount = price - parseInt(discountValue);
                    break;
            }
            if(discount < 0) { discount = 0; }
            subSubtotal = subSubtotal + (quantity * (price - discount));

            if(productList && hasIntervalSelect) {
                otpSubtotal = otpSubtotal + (quantity * price);
            }
        });
    }

    if (otpSubtotal > 0) {
        otpSubtotal = otpSubtotal + productBasePrice;
    }
    if (subSubtotal > 0) {
        const discountType = frequency.dataset.discountType;
        const discountValue = frequency.dataset.discountValue;
        let discount = 0;
        switch(discountType){
            case 'percentage':
                discount = (productBasePrice * parseFloat(discountValue)) / 100;
                break;
            // case 'fixed_amount':
            //     discount = parseInt(discountValue);
            //     break;
            case 'price':
                discount = productBasePrice - parseInt(discountValue);
                break;
            }
        if(discount < 0) { discount = 0; }
        subSubtotal = subSubtotal + (productBasePrice - discount);
    }

    if(productPriceOverride > 0 && productPriceOverrideIndividual == 0) {
        otpSubtotal = subSubtotal = productPriceOverride;
        if(frequency) {
            const discountType = frequency.dataset.discountType;
            const discountValue = frequency.dataset.discountValue;
            let discount = 0;
            switch(discountType){
                case 'percentage':
                    discount = (subSubtotal * parseFloat(discountValue)) / 100;
                    break;
                case 'fixed_amount':
                    discount = parseInt(discountValue) * Math.max(curQuantity, bundleMin);
                    break;
                case 'price':
                    discount = subSubtotal - parseInt(discountValue);
                    break;
                }
            if(discount < 0) { discount = 0; }
            subSubtotal = subSubtotal - discount;
        }
    }

    if (productPriceOverrideIndividual > 0) {
        if (curQuantity < bundleMin) {
            const countRemaining = bundleMin - curQuantity;
            const otpRemainingOverridePrice = countRemaining * productPriceOverrideIndividual;
            let subRemainingOverridePrice = 0;
            if (frequency) {
                const discountType = frequency.dataset.discountType;
                const discountValue = frequency.dataset.discountValue;
                let discount = 0;
                switch(discountType){
                    case 'percentage':
                        discount = (otpRemainingOverridePrice * parseFloat(discountValue)) / 100;
                        break;
                    case 'fixed_amount':
                        discount = parseInt(discountValue) * countRemaining;
                        break;
                    case 'price':
                        discount = otpRemainingOverridePrice - parseInt(discountValue);
                        break;
                    }
                if(discount < 0) { discount = 0; }
                subRemainingOverridePrice = otpRemainingOverridePrice - discount;
            }
            otpSubtotal += otpRemainingOverridePrice;
            subSubtotal += subRemainingOverridePrice;
        }
    }

    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    otpPriceEls.forEach(function(el){
        el.innerHTML = currencyFormatter.format(otpSubtotal / 100);
    });
    subPriceEls.forEach(function(el){
        el.innerHTML = currencyFormatter.format(subSubtotal / 100);
    });
    curPriceEls.forEach(function(el){
        if (interval == 'otp') {
            el.innerHTML = currencyFormatter.format(otpSubtotal / 100);
        } else {
            el.innerHTML = currencyFormatter.format(subSubtotal / 100);
        }
    });
}

async function initializeBundle() {
    const rechargeBundles = document.querySelectorAll('[data-recharge-product-id]');
    if (rechargeBundles) {
        await Promise.all([...rechargeBundles].map(async rechargeBundle => {
            // replace liquid defined data and attributes with info pulled from ReCharge SDK
            const rechargeBundleSettings = await recharge.cdn.getCDNBundleSettings(rechargeBundle.getAttribute('data-recharge-product-id'));
            const blocks = rechargeBundleSettings.variants;
            await Promise.all([...rechargeBundle.querySelectorAll('.lsg-bundle-block')].map(async (bundleBlock, blockIndex) => {
                const blockSettings = blocks[blockIndex];
                const blockMin = blockSettings.ranges[0].quantity_min;
                const blockMax = blockSettings.ranges[0].quantity_max;
                const blockSelectionOptions = blockSettings.option_sources;
                // update block with CDN settings
                bundleBlock.setAttribute('data-otp-bundle-min', blockMin);
                bundleBlock.setAttribute('data-sub-bundle-min', blockMin);
                bundleBlock.setAttribute('data-otp-bundle-max', blockMax);
                bundleBlock.setAttribute('data-sub-bundle-max', blockMax);
                const selectedProductsEls = bundleBlock.querySelectorAll('[data-bundle-builder-selected-products]');
                selectedProductsEls.forEach((selectedProductsEl) => {
                    for (let index = 0; index < blockMax; index++) {
                        const selectedProductPlaceholder = `
                            <div class="bundle-builder__selected-product" data-bundle-builder-selected-product-id data-index="${index}">
                                <div class="bundle-builder__selected-product-img-wrapper">
                                    <div class="bundle-builder__selected-product-placeholder" data-bundle-builder-selected-placeholder-placeholder>
                                    </div>
                                    <img src="" alt="" class="bundle-builder__selected-product-image" data-bundle-builder-selected-product-image>
                                </div>
                                <div class="bundle-builder__selected-product-title-wrap">
                                    <span class="bundle-builder__selected-product-title" data-bundle-builder-selected-product-title></span>
                                </div>
                                <button class="bundle-builder__selected-product-remove-button lsg-bundle-product-select-quantity-minus" data-bundle-builder-selected-product-remove-button></button>
                            </div>
                        `;
                        selectedProductsEl.insertAdjacentHTML('beforeend', selectedProductPlaceholder);
                    }
                });
                await Promise.all(blockSelectionOptions.map(async blockSelectionOption => {
                    const optionCollection = window.collections_json?.find(collection => collection.id == blockSelectionOption.collection_id)?.handle;
                    if (optionCollection) {
                        const collectionRequest = await fetch(`/collections/${optionCollection}?view=bundle-ajax`);
                        const collectionText = await collectionRequest.text();
                        const collectionProducts = new DOMParser().parseFromString(collectionText, 'text/html').querySelector('#bundle_ajax_products').children;
                        const bundleBlockProductList = bundleBlock.querySelector('.lsg-bundle-product-list');
                        const collectionProductsWrapper = document.createElement('div');
                        collectionProductsWrapper.setAttribute('data-bundle-min', `${blockMin}`);
                        collectionProductsWrapper.setAttribute('data-bundle-max', `${blockMax}`);
                        collectionProductsWrapper.className = 'lsg-bundle-product-set-list lsg-bundle-product-sub-list';
                        collectionProductsWrapper.setAttribute('data-lsg-bundle-product-sub-list', ``);
                        collectionProductsWrapper.replaceChildren(...collectionProducts);
                        bundleBlockProductList.replaceChildren(collectionProductsWrapper);
                    }
                }));
                // updateProductProgress(bundleBlock);
            }));
        }));
    }
    //loop through bundle blocks
    document.querySelectorAll('.lsg-bundle-block').forEach(function(bundleBlock){
        //set bundle block classes and initial selling_plan input
        const intervalSelect = bundleBlock.querySelector('.lsg-bundle-interval-select');
        const onlyOTP = bundleBlock.querySelector('.lsg-bundle-interval-only-otp');
        const onlySub = bundleBlock.querySelector('.lsg-bundle-interval-only-sub');
        const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
        const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
        if(intervalSelect){
            //has otp/sub selector
            bundleBlock.classList.add('lsg-bundle--has-interval-select');
            let selectedInterval = intervalSelect.querySelector('input[name^="bundle_interval_select_"]:checked');
            switch(selectedInterval.value){
                case 'otp':
                    bundleBlock.classList.add('lsg-bundle--otp-selected');
                    sellingPlanInput.value = '';
                    break;
                case 'sub':
                    bundleBlock.classList.add('lsg-bundle--sub-selected');
                    sellingPlanInput.value = frequencySelect.value;
                    break;
            }
            updateInterval(selectedInterval);
        } else if (onlyOTP) {
            //has only otp options
            bundleBlock.classList.add('lsg-bundle--only-otp');
            sellingPlanInput.value = '';
        } else if (onlySub) {
            //has only sub options
            bundleBlock.classList.add('lsg-bundle--only-sub');
            sellingPlanInput.value = frequencySelect.value;
        }

        //intial enable/disable for quantity increments and submit button
        bundleBlock.querySelectorAll('.lsg-bundle-product-set-list').forEach(function(productSetList){
            incrementEnableValidation(productSetList.querySelector('.lsg-bundle-product-select-quantity-input'));
        });
        checkoutEnableValidation(sellingPlanInput);
        setTimeout(function(){
            bundleBlock.classList.add('is-initialized');
        }, 500);

        const disclaimerTriggers = bundleBlock.querySelectorAll('[rtx-value-prop-disclaimer-trigger]');
        disclaimerTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const disclaimer = trigger.closest('[rtx-value-prop-disclaimer]');
                if (disclaimer) {
                    disclaimer.classList.add('active');
                }
            });
        });
        const disclaimerOverlays = bundleBlock.querySelectorAll('[rtx-value-prop-disclaimer-overlay]');
        disclaimerOverlays.forEach(overlay => {
            overlay.addEventListener('click', () => {
                const disclaimer = overlay.closest('[rtx-value-prop-disclaimer]');
                if (disclaimer) {
                    disclaimer.classList.remove('active');
                }
            });
        });
    });
}

function getBundleQuantity(trigger) {
    //gets the quantity of the current active bundle block product list
    let bundleBlock = getBundleBlock(trigger);
    let quantity = -1;
    let productList = bundleBlock.querySelector('.lsg-bundle-product-set-list');
    if(productList){
        quantity = 0;
        productList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
            quantity = quantity + parseInt(input.value);
        });
    }
    return quantity;
}

function getBundleQuantityByChild(trigger){
    const productSetList = trigger.closest('.lsg-bundle-product-set-list');
    let quantity = -1;
    if(productSetList){
        quantity = 0;
        productSetList.querySelectorAll('.lsg-bundle-product-select-quantity-input').forEach(function(input){
            quantity = quantity + parseInt(input.value);
        });
    }
    return quantity;
}

function getBundleInterval(trigger) {
    //checks if the bundle is set to display OTP or suscription options
    let bundleBlock = getBundleBlock(trigger);
    if(bundleBlock.classList.contains('lsg-bundle--has-interval-select')) {
        if(bundleBlock.classList.contains('lsg-bundle--otp-selected')) {
            return 'otp';
        }
        if(bundleBlock.classList.contains('lsg-bundle--sub-selected')) {
            return 'sub';
        }
    }
    if(bundleBlock.classList.contains('lsg-bundle--only-otp')) {
        return 'otp';
    }
    if(bundleBlock.classList.contains('lsg-bundle--only-sub')) {
        return 'sub';
    }
    return 'err';
}

function getBundleBlock(trigger) {
    return trigger.closest('.lsg-bundle-block');
}

function getGuid() {
    let d = new Date().getTime();
    let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
    });
}

// lemma js - mobile device adjustment
(function () {
  const LOG_PREFIX = "[bundle-scroll]";
  const MOBILE_QUERY = window.matchMedia("(max-width: 479px)");

  function log(...args) { console.log(LOG_PREFIX, ...args); }
  function warn(...args) { console.warn(LOG_PREFIX, ...args); }

  function onReady(fn) {
    // iOS often loads scripts after DOMContentLoaded; this handles both cases.
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function initBundleScroll() {
    log("init called", { readyState: document.readyState, mobile: MOBILE_QUERY.matches });

    if (window.__bundleScrollObserver) {
      try { window.__bundleScrollObserver.disconnect(); } catch (e) {}
      window.__bundleScrollObserver = null;
    }

    const countContainer =
      document.querySelector(".lsg-bundle-sticky-bar .bundle-builder__selected-products") ||
      document.querySelector(".bundle-builder__selected-products");

    if (!countContainer) {
      warn("no countContainer found");
      return;
    }

    function getActiveCount() {
      return countContainer.querySelectorAll(".bundle-builder__selected-product.active").length;
    }

    function getContainers() {
      return Array.from(document.querySelectorAll(".bundle-builder__selected-products"));
    }

    function scrollContainers(reason) {
      const count = getActiveCount();
      const containers = getContainers();
      log("scroll", { reason, count, containers: containers.length });

      containers.forEach((el, idx) => {
        const maxScroll = el.scrollWidth - el.clientWidth;
        log("metrics", { idx, maxScroll, scrollWidth: el.scrollWidth, clientWidth: el.clientWidth, before: el.scrollLeft });

        if (maxScroll <= 0) return;

        el.scrollLeft = (count <= 5) ? 0 : maxScroll;

        log("after", { idx, after: el.scrollLeft });
      });
    }

    // run a few times because iOS/layout can settle late
    scrollContainers("init immediate");
    setTimeout(() => scrollContainers("init +150ms"), 150);
    setTimeout(() => scrollContainers("init +600ms"), 600);

    const observer = new MutationObserver(() => {
      // do a small delay because class flips can land after DOM mutation
      setTimeout(() => scrollContainers("mutation +30ms"), 30);
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });

    window.__bundleScrollObserver = observer;
    window.__bundleScrollApply = (why) => scrollContainers(why || "manual");
    log("initialized");
  }

  function teardown() {
    if (window.__bundleScrollObserver) {
      try { window.__bundleScrollObserver.disconnect(); } catch (e) {}
      window.__bundleScrollObserver = null;
      log("torn down");
    }
  }

  function handleViewport() {
    log("viewport check", { mobile: MOBILE_QUERY.matches });
    if (MOBILE_QUERY.matches) initBundleScroll();
    else teardown();
  }

  onReady(handleViewport);
  window.addEventListener("load", () => {
    // catches late-rendering builders on mobile
    if (MOBILE_QUERY.matches && typeof window.__bundleScrollApply === "function") {
      window.__bundleScrollApply("window load");
    }
  });

  MOBILE_QUERY.addEventListener("change", handleViewport);
})();